import { createSelector } from '@reduxjs/toolkit';
import { EGarageType } from '../../../../packages/JsonQuery';
import { selectGarageType } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Гараж', value: EGarageType.Garage },
  { label: 'Машиноместо', value: EGarageType.CarPlace },
  { label: 'Бокс', value: EGarageType.Box },
];

export const selectGarageTypeFilter = createSelector(selectGarageType, value => ({
  label: 'Тип',
  value: value?.length ? (value as EGarageType[]) : [null],
  options: OPTIONS,
}));
